import { Injectable } from '@angular/core';
import { PaetepUserService } from '../paetep-user.service';
import { SessionService, User } from '@edl-development/edl-common';
import { firstValueFrom } from 'rxjs';
import { BaseUserDTO } from 'src/app/model/base/base-user-dto.model';
import { SupervisorUserDTO } from 'src/app/model/base/supervisor-user-dto.model';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';

@Injectable({
    providedIn: 'root'
})
export class PaetepUserHelperService {

    constructor(
        private paetepUserService: PaetepUserService,
        private sessionService: SessionService
    ) { }

    getSelectEvaluatorOptions(
        targetUserId: string, 
        canCreateObservation: boolean,
        observationsTargetUserCanHave: ObservationTypeValues[],
        currentEvalUser?: {
            userId: string
            displayName: string
    }): Promise<SupervisorUserDTO[]> {
        return firstValueFrom(
            this.paetepUserService.getSupervisors(targetUserId)
        ).then((supervisors: SupervisorUserDTO[]) => {
            const currentUser = this.sessionService.user;
            let evaluators = [...supervisors];
    
            // Include current user if they do not show up in the evaluator list
            if (currentUser && canCreateObservation && evaluators.findIndex(e => e.user.userID == currentUser?.UserID) === -1) {
                evaluators = [{ 
                    user: { userID: currentUser.UserID, displayName: currentUser.DisplayName },
                    observationsSupervisorCanManage: observationsTargetUserCanHave
                }, ...evaluators]
            }
    
            // If current evaluator is not in the list then we need to add them
            if (currentEvalUser && evaluators.findIndex(e => e.user.userID == currentEvalUser.userId) === -1) {
                evaluators = [{ 
                    user: { userID: currentEvalUser.userId, displayName: currentEvalUser.displayName},
                    observationsSupervisorCanManage: observationsTargetUserCanHave
                }, ...evaluators]
            }

            // filter out target user
            evaluators = evaluators.filter(e => e.user.userID !== targetUserId);
    
            evaluators = evaluators.sort((a, b) => a.user.displayName < b.user.displayName ? -1 : 1);

            return evaluators;
        })
    }
}
